// HelpContent component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class HelpContent extends Component {
  static get propTypes () {
    return {
      content: PropTypes.string,
      bAnimate: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      content: null,
      bAnimate: true
    }
  }

  render () {
    const _clsName = classnames('helpcont typo typo_help', {
      helpcont_animatecont: this.props.bAnimate,
      helpcont_animateall: !this.props.bAnimate
    })

    return (
      <div className={_clsName}>
        <div dangerouslySetInnerHTML={{ __html: this.props.content }} />
      </div>
    )
  }
}

export default HelpContent
